import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {IEDate, uGetDateFormat} from '@appbase/util';

import EventDetailHover from '@reserve/components/EventDetailHover.vue';
import {mapGetters} from "vuex";
import * as types from "@reserve/store/types";

@Component({
    components: {
        EventDetailHover
    },

    computed: mapGetters({
        currentDate: types.CALENDAR_DATE_CURRENT,
    })
})
export default class EventItem  extends Vue {
    @Prop({ type: Object }) item!: reserve.CalendarItem;

    currentDate!: reserve.DateItem;

    height: number = 0;

    colorClass: any = {};        

    created() {        
        this.colorClass[this.item.color] = true;
        this.height = this.getDisplayHeight();
    }

    /*getDisplayHeight(): number {
        if(this.item.isAllDayEvent) {
            return 48;
        } else {
            let startDate = IEDate(this.item.start);
            let endDate = IEDate(this.item.end);

            var timeinmills = endDate.getTime() - startDate.getTime();
            return timeinmills / (1000 * 60 * 30);
        }
    }*/

    getDisplayHeight(): number {
        if (this.item.isAllDayEvent) {
            return 48; // 종일 이벤트의 높이 반환
        } else {
            let startDate = IEDate(this.item.start); // 일정 시작 시간
            let endDate = IEDate(this.item.end); // 일정 종료 시간
            let lastHeight = 0; // 반환할 마지막 높이 저장

            let curDateStr = uGetDateFormat('yyyy-MM-dd', IEDate(this.currentDate.date));// 선택된날짜
            const dayStart = new Date(curDateStr);
            dayStart.setHours(0, 0, 0, 0); // 자정 시간
            const dayEnd = new Date(curDateStr);
            dayEnd.setHours(23, 59, 59, 999); // 해당 날짜의 마지막 시간

            // 현재 날짜에서 계산할 시간
            let timeOnThisDay;
            // 선택된 시간의 마지막 시간보다 종요일이 더 늦을떄
            if (dayEnd < endDate) {
                timeOnThisDay =  dayEnd.getTime() - startDate.getTime();
            } else {
                // 선택된 날짜가 시작일이 작거나 같을때
                if(dayStart <= startDate){
                    timeOnThisDay =endDate.getTime() - startDate.getTime();
                }else{
                    timeOnThisDay =endDate.getTime() - dayStart.getTime();
                }
            }

            let height = timeOnThisDay / (1000 * 60 * 30); // 30분 단위 높이 계산

            // 최대 높이를 48로 제한
            if (height > 48) height = 48;

            // 날짜별 높이 출력
            // console.log(`날짜: ${dayStart.toLocaleDateString()}, 높이: ${height}`);

            // 마지막 높이를 저장
            lastHeight = height;

            // 마지막으로 계산된 높이를 반환
            return lastHeight;
        }
    }

    onEventDblClick() {
        this.$emit('open', this.item);
    }
}